// extracted by mini-css-extract-plugin
module.exports = {"ConfirmationPage":"ConfirmationPage_ConfirmationPage__1TmyA","main":"ConfirmationPage_main__2fLyg","logInBtn":"ConfirmationPage_logInBtn__2QBrP"};